import React from 'react'
import PropTypes from 'prop-types'
import { cn } from 'shared/util/cn'

const variants = {
  primary: 'bg-theme text-light hover:bg-theme-400 shadow-glow',
  success: 'bg-success text-light hover:opacity-90',
  warning: 'bg-primary text-dark hover:bg-primary-600',
  danger: 'bg-danger text-light hover:opacity-90',
  ghost: 'bg-elevated text-ink border border-line hover:border-theme',
  outline: 'bg-transparent text-theme border border-theme hover:bg-theme-900'
}

function Button({
  children,
  className = '',
  variant = 'primary',
  isSmall,
  btnColor,
  outlined,
  disabled = false,
  href,
  type = 'button',
  ...rest
}) {
  const Tag = href ? 'a' : 'button'
  const resolved = outlined ? 'outline' : btnColor ? 'ghost' : variant
  return (
    <Tag
      type={href ? undefined : type}
      href={href}
      disabled={disabled}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-2xl border border-transparent text-center font-semibold',
        isSmall ? 'min-h-tap px-4 text-sm' : 'min-h-12 px-5 py-3',
        variants[resolved] || variants.primary,
        disabled && 'cursor-not-allowed border-dark-600 !bg-dark-600 !text-light opacity-70',
        className
      )}
      {...rest}
    >
      {children}
    </Tag>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
  variant: PropTypes.string,
  outlined: PropTypes.bool,
  href: PropTypes.string,
  disabled: PropTypes.bool,
  isSmall: PropTypes.bool,
  btnColor: PropTypes.bool,
  type: PropTypes.string
}

export default React.memo(Button)
